<div style='display: flex'>
  <span>{{data}}</span>
  <span style='margin-right: -15px !important;margin-top: -6px;margin-bottom: -9px;'>
  <button mat-button  (click)="_snackRef.dismissWithAction()"><mat-icon>close</mat-icon></button>
</span>
</div>
